import React, {Component} from 'react';
import GlobalSearchResults from './global_search_results';
import ForecastQueryRenderer from '../../ForecastQueryRenderer';
import UploadingOverlay from '../../forecast-app/shared/components/uploading-overlay/uploading_overlay';

import {globalSearchResultsQuery} from './global_search_results';

class GlobalSearchRenderer extends Component {
	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return (
			JSON.stringify(this.props.searchQuery) !== JSON.stringify(nextProps.searchQuery) ||
			JSON.stringify(this.props.resultCategoryExpandedMap) !== JSON.stringify(nextProps.resultCategoryExpandedMap) ||
			nextProps.selectedResultIndex !== this.props.selectedResultIndex ||
			nextProps.selectedResultsCategoryIndex !== this.props.selectedResultsCategoryIndex ||
			this.props.taskResultsCount !== nextProps.taskResultsCount ||
			this.props.imitateClickAtSelectedIndex !== nextProps.imitateClickAtSelectedIndex
		);
	}

	render() {
		const searchQuery = this.props.searchQuery;
		return (
			<ForecastQueryRenderer
				key="query-render-globalSearchResults"
				componentName="global_search"
				variables={{searchQuery: searchQuery}}
				query={globalSearchResultsQuery}
				showLoader={true}
				customLoader={() => (
					<div className="global-search-results-dropdown">
						<UploadingOverlay />
					</div>
				)}
				render={(relayProps, retry) => {
					return (
						<GlobalSearchResults
							{...relayProps}
							retry={retry}
							seeAllTaskResults={this.props.seeAllTaskResults}
							expanded={this.props.expanded}
							searchQuery={this.props.searchQuery}
							showTaskModal={this.props.showTaskModal}
							close={this.props.close}
							taskResultsCount={this.props.taskResultsCount}
							selectedResultsCategoryIndex={this.props.selectedResultsCategoryIndex}
							selectedResultIndex={this.props.selectedResultIndex}
							updateTaskSearchResultsCount={this.props.updateTaskSearchResultsCount}
							resultCategoryExpandedMap={this.props.resultCategoryExpandedMap}
							toggleResultCategoryExpand={this.props.toggleResultCategoryExpand}
							imitateClickAtSelectedIndex={this.props.imitateClickAtSelectedIndex}
							selectOptionAtIndex={this.props.selectOptionAtIndex}
							deselectOptionsAtIndex={this.props.deselectOptionsAtIndex}
						/>
					);
				}}
			/>
		);
	}
}
export default GlobalSearchRenderer;
